// AUPRÉA — Étape 20 : quelles réponses déclenchent chaque service préconisé (miroir des règles de preconisationsEngine.js)
const S = (p) => [1, 2, 3, 4, 5].map(q => `s${p}q${q}`);
const S_ALL = [...S(1), ...S(2), ...S(3), "recompose", "indivision", "deces"];
const D_ALL = ["d1q1", "d1q2", "d1q3", "d2q1", "d2q2", "d2q3", "d3q1", "d3q2", "d3q3", "d4q1", "d4q2", "d5q1", "d5q2", "d5q3"];

const TRIGGERS = {
  bilan_succession: {
    AUDIT: S(1), DUO: S(1), CONF: S(1), ESS: S_ALL,
    ATELIER: ["s1q5", "s2q2", "s2q5", "recompose"],
    ORI_NOT: S(2), PPLUS: S(2), ORI_CGP: S(3), FCF: ["indivision"],
    SUIVI: S_ALL, CONS: S_ALL,
  },
  bilan_dirigeants: {
    PACKT: [...D_ALL], PACKS: ["d3q1", "d4q1", "d4q2", ...D_ALL], PACKC: ["d1q1", "d1q2", "d1q3", "d5q2", ...D_ALL], PCD: D_ALL, PCDM: D_ALL,
    AGF: ["d3q1", "d4q1", "d4q2"], ORI_ASS: ["d4q1", "d4q2"], COORD: ["d2q1", "d2q2", "d2q3", "d3q1", "d3q2", "d3q3"],
    SUIVD: D_ALL, CONSD: D_ALL, PPLUS: D_ALL,
  },
};

// 0 = défavorable, 1 = intermédiaire, null = rien à reformuler
const gravite = (code, v) => {
  const x = String(v ?? "").toLowerCase();
  if (["recompose", "indivision", "deces"].includes(code)) return x === "oui" ? 0 : null;
  if (/^d\dq\d$/.test(code)) return x === "c" ? 0 : x === "b" ? 1 : null;
  return x === "non" ? 0 : x.startsWith("partiel") ? 1 : null;
};

const minuscule = (t) => t.charAt(0).toLowerCase() + t.slice(1);

export const reformulationsPour = (serviceCode, parcours, reformulations, max = 3) => {
  const type = parcours.type_parcours;
  const codes = [...new Set((TRIGGERS[type] || {})[serviceCode] || [])];
  const rep = { ...(parcours.reponses || {}), ...(parcours.reponses_complementaires || {}) };
  const textes = Object.fromEntries(reformulations.filter(r => r.type_parcours === type).map(r => [r.code, r.texte]));
  return codes
    .map((c, ordre) => ({ c, g: gravite(c, rep[c]), ordre }))
    .filter(x => x.g !== null && textes[x.c])
    .sort((a, b) => a.g - b.g || a.ordre - b.ordre)
    .slice(0, max)
    .map(x => {
      const t = textes[x.c].trim().replace(/\.$/, "");
      return { code: x.c, gravite: x.g, texte: `Vous m'avez dit que ${minuscule(t)}${x.g === 1 ? ", en partie seulement" : ""}.` };
    });
};
